import { App } from './components/App'
import './index.css'
//
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => new App()) : new App()
